import { render, staticRenderFns } from "./WebsiteOffers.vue?vue&type=template&id=10b20086"
import script from "./WebsiteOffers.vue?vue&type=script&lang=js"
export * from "./WebsiteOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports